import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ApiVisa } from "blg-akaun-ts-lib";
import { SessionActions } from "../../modules/session/session-controller/actions";
import { SessionSelectors } from "../../modules/session/session-controller/selectors";
import { SessionStates } from "../../modules/session/session-controller/states";
import { ReplaySubject, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DropDownService } from "../../services/drop-down-service";
import { SharedUtilitiesHelperFunctions } from "../helper-functions";

@Component({
  selector: "app-select-supplier-dropdown",
  templateUrl: "./select-supplier-dropdown.component.html",
  styleUrls: ["./select-supplier-dropdown.component.css"],
})
export class SelectSupplierDropdownComponent implements OnInit, OnDestroy {
  @Input() supplier: FormControl; // holds the array of selected supplier guids
  @Input() apiVisa: ApiVisa;
  @Input() selectedGuids: string[] = []; // stores multiple guids for multiple selection
  @Input() label = "Supplier";
  @Output() supplierSelected = new EventEmitter<any[]>(); // emits array of selected suppliers

  serverSideFiltering = new FormControl(); // control for searching/filtering suppliers
  filteredOptions$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1); // filtered options for display
  selectedRows: any[] = []; // stores the selected supplier rows (multiple suppliers)
  rowData: any = []; // raw data of suppliers
  key = "supplier";

  protected _onDestroy = new Subject<void>();

  constructor(
    private dropDownService: DropDownService,
    private readonly store: Store<SessionStates>
  ) {}

  ngOnInit() {
    this.store
      .select(SessionSelectors.selectDropDownRowData)
      .subscribe((resolved) => {
        this.rowData = resolved
          ? resolved[this.key]
            ? resolved[this.key]
            : []
          : [];
        console.log("rowData.length", this.rowData.length);
        if (this.rowData.length === 0) {
          this.getRowData(); // fetch the row data if it's not already available
        } else {
          this.filteredOptions$.next(this.rowData.slice()); // populate dropdown with existing data
        }
      });

    // listen for search field value changes
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtering();
      });
  }

  // Fetches supplier row data from API
  getRowData(keyword?: string) {
    const formData = {
      "keyword" : ( keyword ? keyword : ''),
      limit: "",
      orderBy: "name",
      order: "ASC",
    };
    this.dropDownService
      .get("supplier", formData, this.apiVisa)
      .subscribe((resolved) => {
        this.rowData = [...this.rowData, ...resolved.data];
        this.rowData = SharedUtilitiesHelperFunctions.removeDuplicate(this.rowData, "guid");
        this.rowData = this.rowData.filter((entity) => entity.name !== ""); // remove suppliers with no name

        this.store.dispatch(
          SessionActions.selectDropDownRowData({
            key: this.key,
            rowData: this.rowData,
          })
        );

        if (keyword) {
          this.filteredOptions$.next(resolved.data.slice());
        } else {
          this.filteredOptions$.next(this.rowData.slice());
        }
      });
  }

  filtering() {
    if (!this.rowData) {
      return;
    }

    // get the search keyword
    let search = this.serverSideFiltering.value;
    console.log("Filter Data", search);
    if (!search || search.length < 3) {
      this.filteredOptions$.next(this.rowData.slice());
      return;
    } else {
      search = search.toLowerCase();
      this.getRowData(search);
    }
  }

  // Handles the selection of a supplier (or deselection if already selected)
  onSelect(guid: string) {
    const index = this.selectedGuids.indexOf(guid);
    if (index === -1) {
      // Add new selection if it doesn't exist in selectedGuids
      this.selectedGuids.push(guid);
    } else {
      // Remove selection if it already exists
      this.selectedGuids.splice(index, 1);
    }

    // Update the FormControl and selectedRows
    this.supplier.patchValue(this.selectedGuids); // FormControl now holds selected guids
    this.selectedRows = this.rowData.filter((row) =>
      this.selectedGuids.includes(row.guid)
    );
    this.supplierSelected.emit(this.selectedRows); // Emit the selected supplier rows
  }

  // Clear the selection (optional utility)
  clearSelection() {
    this.selectedGuids = [];
    this.supplier.patchValue(this.selectedGuids);
    this.selectedRows = [];
    this.supplierSelected.emit(this.selectedRows); // emit empty selection
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
